var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityList',{attrs:{"config":_vm.config,"columns":_vm.columns,"form-fields":_vm.formFields,"authority":"Questionnaire_Management_Questionnaire"}})}
var staticRenderFns = []

export { render, staticRenderFns }